<template>
  <div class="card add-bill-modifier has-rounded-top-corners">
    <div class="card-content add-bill-card-modifier">
      <div class="container has-text-weight-semibold has-text-centered">
        <h3 class="title is-4 has-baskerville-font has-text-brand-color mb-5">
          Delete Name
        </h3>
      </div>
      <div class="container">
        <label class="label">
          Delete <span class="has-text-danger">"{{ name }}"</span>?
        </label>
        <div class="is-size-7 has-text-grey-light mb-4">
          Names used in any bill item cannot be deleted.
        </div>
        <p v-if="errorMessage" class="notification is-danger is-light is-size-7 py-2 px-3 mb-3">
          {{ errorMessage }}
        </p>
        <div class="control">
          <div
            @click="deleteName()"
            v-bind:class="{'is-loading': loading}"
            class="button is-danger is-fullwidth mt-3 mb-3"
            :disabled="loading"
          >
            Delete "{{ name }}"
          </div>
        </div>
        <div
          v-if="!loading"
          class="container mb-6 has-text-centered has-text-grey"
        >
          <div @click="toggleDeleteNameScreen()" class="is-clickable is-unselectable back-button-modifier">
            back
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { masterFunction } from '@/firebase/init'

export default {
  name: 'DeleteName',
  props: ['name'],
  data() {
    return {
      loading: false,
      errorMessage: null
    }
  },
  computed: {
    event() {
      return this.$store.state.event
    }
  },
  methods: {
    deleteName() {
      if (!this.loading) {
        this.loading = true
        this.errorMessage = null
        masterFunction({
          methodName: 'remove-name',
          eventId: this.event.eventId,
          name: this.name,
          adminKey: this.$store.state.adminKey
        }).then(() => {
          if (this.$store.state.name === this.name) {
            this.$store.commit('updateName', null)
          }
          this.loading = false
          this.toggleDeleteNameScreen()
        }).catch(err => {
          this.loading = false
          if (err && err.message && err.message.includes('Name is in use')) {
            this.errorMessage = 'Cannot delete — this name is used in one or more bill items.'
          } else {
            this.errorMessage = err.message || 'Something went wrong.'
          }
        })
      }
    },
    toggleDeleteNameScreen() {
      if (!this.loading) {
        this.$emit('toggleDeleteNameScreen', false)
      }
    }
  }
}
</script>

<style>
</style>
